import { FC } from 'react'
import styled from 'styled-components'
import { Input, InputProps } from '../Input'
import { Button, ButtonProps } from '../Button'
import { SendIcon } from '../icons/SendIcon'

type InputAndSubmitButtonProps = InputProps &
  Pick<ButtonProps, 'onClick'> & {
    isUnUseDisable?: boolean
  }
export const InputAndSubmitButton: FC<InputAndSubmitButtonProps> = (props) => {
  const { onClick, value, placeholder, onChange, onKeyPress, isUnUseDisable } = props

  const disabled = !isUnUseDisable && !value

  return (
    <StyledInputWrap>
      <Input value={value} placeholder={placeholder} onChange={onChange} onKeyPress={onKeyPress} />
      <Space size={10} />
      <Button buttonType="icon" onClick={onClick} disabled={disabled}>
        <SendIcon disabled={disabled} />
      </Button>
    </StyledInputWrap>
  )
}

const StyledInputWrap = styled.div`
  display: flex;
`
const Space = styled.div<{ size: number }>`
  width: ${({ size }) => `${size}px`};
  height: 1px;
`
